/* eslint-disable no-console */
import travellaHeader from "../TravellaHeader";
import SettingsService from "../../shared/settings/settings.service.js";
import Dialog from 'primevue/dialog';
import Panel from 'primevue/panel';
import Button from 'primevue/button';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';

export default {
    name: "TabelaObrotow",
    components: { Dialog, Panel, Button, Dropdown, InputNumber, InputText, FileUpload, Toast },
    data: function () {
        return {
            modalDisabled: false,
            oddzial: false,
            callcenter: false,
            sumaSprzedazyObcej: 0,
            sumaProwizjiSprzedazyObcej: 0,
            dialogDisplay: false,
            accordionDisplay: false,
            APIurl: process.env.VUE_APP_API_URL,
            selectedMonth: "",
            highLighted: 0,
            danePodwladnych: {
                Podwladni: []
            },
            sprzedazObcaDanePobrane: [],
            sprzedazObcaDane: {
                typ: "",
                ksk: {
                    imieNazwisko: "",
                    kwota100: null
                },
                bonWakacyjny: {
                    kodBonu: "",
                    kwota100: null
                },
                sprzedazObca: {
                    nazwaSprzedazy: "",
                    kwota100: null,
                    prowizja100: null,
                    pdf: {
                        nazwaPliku: "",
                        plikBase64: ""
                    }
                }
            },
            sprzedazObcaDaneModal: {
                typ: "",
                ksk: {
                    imieNazwisko: "",
                    kwota100: null
                },
                bonWakacyjny: {
                    kodBonu: "",
                    kwota100: null
                },
                sprzedazObca: {
                    nazwaSprzedazy: "",
                    kwota100: null,
                    prowizja100: null,
                    pdf: {
                        nazwaPliku: "",
                        plikBase64: ""
                    }
                }
            },
            sprzedazObcaSelectTypu: [
                { name: "Sprzedaz obca", labelValue: "Sprzedaz obca" },
                { name: "Sprzedaz bonu", labelValue: "Sprzedaz bonu" },
            ],
            daneObrotu: {
                K_50_50: {
                    First: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Last: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Middle: {
                        Obrot: 0,
                        Premia: 0
                    }
                },
                Travella: {
                    First: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Last: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Middle: {
                        Obrot: 0,
                        Premia: 0
                    }
                },
                WWW: {
                    First: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Last: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Middle: {
                        Obrot: 0,
                        Premia: 0
                    }
                },
                SSS: {
                    First: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Last: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Middle: {
                        Obrot: 0,
                        Premia: 0
                    }
                },
                Uproszczona: {
                    First: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Last: {
                        Obrot: 0,
                        Premia: 0
                    },
                    Middle: {
                        Obrot: 0,
                        Premia: 0
                    }
                }
            },
            daneRaportu: {
                Premia: 0,
                DynamikaSprzedazy: null,
                DynamikaSprzedazyCCW: null,
                Monitoring: {
                    Wartosc: 0,
                    Premia: 0
                },
                PremiaDodatkowa: 0,
                SeatingsStandard: {
                    Wartosc: 0,
                    Premia: 0
                },
                SeatingsPremium: {
                    Wartosc: 0,
                    Premia: 0
                },
                Seatings: {
                    Wartosc: 0,
                    Premia: 0
                },
                SeatingsDreamliner: {
                    Wartosc: 0,
                    Premia: 0
                },
                Fakultety: {
                    Wartosc: 0,
                    Premia: 0
                },
                Hotele: {
                    Hotel1: {
                        Premia: 0
                    }
                },
                Obrot: {
                    K_50_50: {
                        First: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Last: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Middle: {
                            Obrot: 0,
                            Premia: 0
                        }
                    },
                    Travella: {
                        First: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Last: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Middle: {
                            Obrot: 0,
                            Premia: 0
                        }
                    },
                    WWW: {
                        First: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Last: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Middle: {
                            Obrot: 0,
                            Premia: 0
                        }
                    },
                    SSS: {
                        First: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Last: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Middle: {
                            Obrot: 0,
                            Premia: 0
                        }
                    },
                    Uproszczona: {
                        First: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Last: {
                            Obrot: 0,
                            Premia: 0
                        },
                        Middle: {
                            Obrot: 0,
                            Premia: 0
                        }
                    }
                }
            },
            sumaTurystyka: {
                Obrot: 0,
                Premia: 0,
                PremiaZUslugami: 0,
                wartoscUslug: 0,
                First: {
                    Obrot: 0,
                    Premia: 0
                },
                Middle: {
                    Obrot: 0,
                    Premia: 0
                },
                Last: {
                    Obrot: 0,
                    Premia: 0
                },
                Travella: {
                    Obrot: 0,
                    Premia: 0
                },
                WWW: {
                    Obrot: 0,
                    Premia: 0
                },
                K_50_50: {
                    Obrot: 0,
                    Premia: 0
                },
                SSS: {
                    Obrot: 0,
                    Premia: 0
                },
                Uproszczona: {
                    Obrot: 0,
                    Premia: 0
                }
            },
            uslug: {},
            kluczeUslug: [],
            kluczeHoteli: [],
            miesiacRaportu: Number,
            rokRaportu: 2019,
            problem: false,
            dzisiejszaData: new Date(),
            maksymalnaData: Number,
            maksymalnyRok: Number,
            klucze: [],
            startProjektuMiesiac: 5,
            startProjektuRok: 2019,
            kierownik: 0,
            pracownik: [],
            wybranyPracownik: "JA",
            loginy: []
        };
    },
    watch: {
        miesiacRaportu: function () {
            this.getDane(this.miesiacRaportu, this.rokRaportu);
            this.$nextTick(() => {
                this.sprawdzDate();
            });
        },
        rokRaportu: function () {
            this.$nextTick(() => {
                if (this.rokRaportu == this.dzisiejszaData.getFullYear() - 1) {
                    this.miesiacRaportu = 12;
                } else if (this.rokRaportu == this.dzisiejszaData.getFullYear()) {
                    this.miesiacRaportu = 1 + this.dzisiejszaData.getMonth();
                } else {
                    this.getDane(this.miesiacRaportu, this.rokRaportu);
                    this.sprawdzDate();
                }
            });
        },
        wybranyPracownik: function () {
            for (let i = 0; i < this.danePodwladnych.Podwladni.length; i++) {
                if (this.danePodwladnych.Podwladni[i].Login == this.wybranyPracownik) {
                    this.idUzytkownika = this.danePodwladnych.Podwladni[i].UzytkownikId;

                    this.getDanePodwladnego(
                        this.miesiacRaportu,
                        this.rokRaportu,
                        this.idUzytkownika
                    );
                } else if (this.wybranyPracownik == "JA") {
                    this.getDane(this.miesiacRaportu, this.rokRaportu);
                }
            }
        },
        dialogDisplay: function () {
            if (this.dialogDisplay == false) {
                this.sprzedazObcaDane = {
                    typ: "",
                    ksk: {
                        imieNazwisko: "",
                        kwota100: null
                    },
                    bonWakacyjny: {
                        kodBonu: "",
                        kwota100: null
                    },
                    sprzedazObca: {
                        nazwaSprzedazy: "",
                        kwota100: null,
                        prowizja100: null,
                        pdf: {
                            nazwaPliku: "",
                            plikBase64: ""
                        }
                    }
                }
            }
        },
        sprzedazObcaDaneModal: {
            handler() {
                this.$nextTick(() => {
                    this.sprawdzModal();
                });
            },
            deep: true
        }
    },
    methods: {
        sprawdzDate() {
            if (this.rokRaportu == this.dzisiejszaData.getFullYear() - 1) {
                this.maksymalnaData = 12;
            } else if (this.rokRaportu == this.dzisiejszaData.getFullYear()) {
                this.maksymalnaData = 1 + this.dzisiejszaData.getMonth();
            }
        },
        pobierzPlik() {
            this.$nextTick(() => {
                travellaHeader.downloadFile(this.rokRaportu, this.miesiacRaportu);
            });
        },
        updateNaApce(value) {
            this.czyLaduje = value;
            this.$emit("test", value);
        },
        sumaPieniedzy() {
            if (this.daneRaportu.Obrot.Travella.First || this.daneRaportu.Obrot.Travella.Middle || this.daneRaportu.Obrot.Travella.Last) {
                this.sumaTurystyka.Travella.Obrot =
                    this.daneRaportu.Obrot.Travella.First.Obrot +
                    this.daneRaportu.Obrot.Travella.Middle.Obrot +
                    this.daneRaportu.Obrot.Travella.Last.Obrot;
                this.sumaTurystyka.Travella.Premia =
                    this.daneRaportu.Obrot.Travella.First.Premia +
                    this.daneRaportu.Obrot.Travella.Middle.Premia +
                    this.daneRaportu.Obrot.Travella.Last.Premia;
            }

            if (this.daneRaportu.Obrot.WWW.First || this.daneRaportu.WWW.Middle || this.daneRaportu.WWW.Last) {
                this.sumaTurystyka.WWW.Obrot =
                    this.daneRaportu.Obrot.WWW.First.Obrot +
                    this.daneRaportu.Obrot.WWW.Middle.Obrot +
                    this.daneRaportu.Obrot.WWW.Last.Obrot;

                this.sumaTurystyka.WWW.Premia =
                    this.daneRaportu.Obrot.WWW.First.Premia +
                    this.daneRaportu.Obrot.WWW.Middle.Premia +
                    this.daneRaportu.Obrot.WWW.Last.Premia;
            }

            if (this.daneRaportu.Obrot.K_50_50.First || this.daneRaportu.K_50_50.Middle || this.daneRaportu.K_50_50.Last) {
                this.sumaTurystyka.K_50_50.Obrot =
                    this.daneRaportu.Obrot.K_50_50.First.Obrot +
                    this.daneRaportu.Obrot.K_50_50.Middle.Obrot +
                    this.daneRaportu.Obrot.K_50_50.Last.Obrot;

                this.sumaTurystyka.K_50_50.Premia =
                    this.daneRaportu.Obrot.K_50_50.First.Premia +
                    this.daneRaportu.Obrot.K_50_50.Middle.Premia +
                    this.daneRaportu.Obrot.K_50_50.Last.Premia;
            }

            if (this.daneRaportu.Obrot.SSS.First || this.daneRaportu.SSS.Middle || this.daneRaportu.SSS.Last) {
                this.sumaTurystyka.SSS.Premia =
                    this.daneRaportu.Obrot.SSS.First.Premia +
                    this.daneRaportu.Obrot.SSS.Middle.Premia +
                    this.daneRaportu.Obrot.SSS.Last.Premia;

                this.sumaTurystyka.SSS.Obrot =
                    this.daneRaportu.Obrot.SSS.First.Obrot +
                    this.daneRaportu.Obrot.SSS.Middle.Obrot +
                    this.daneRaportu.Obrot.SSS.Last.Obrot;
            }

            if (this.daneRaportu.Obrot.Uproszczona.First || this.daneRaportu.Uproszczona.Middle || this.daneRaportu.Uproszczona.Last) {
                this.sumaTurystyka.Uproszczona.Premia =
                    this.daneRaportu.Obrot.Uproszczona.First.Premia +
                    this.daneRaportu.Obrot.Uproszczona.Middle.Premia +
                    this.daneRaportu.Obrot.Uproszczona.Last.Premia;

                this.sumaTurystyka.Uproszczona.Obrot =
                    this.daneRaportu.Obrot.Uproszczona.First.Obrot +
                    this.daneRaportu.Obrot.Uproszczona.Middle.Obrot +
                    this.daneRaportu.Obrot.Uproszczona.Last.Obrot;
            }

            this.sumaTurystyka.First.Obrot =
                this.daneRaportu.Obrot.Travella.First.Obrot +
                this.daneRaportu.Obrot.WWW.First.Obrot +
                this.daneRaportu.Obrot.K_50_50.First.Obrot +
                this.daneRaportu.Obrot.SSS.First.Obrot +
                this.daneRaportu.Obrot.Uproszczona.First.Obrot;

            this.sumaTurystyka.First.Premia =
                this.daneRaportu.Obrot.Travella.First.Premia +
                this.daneRaportu.Obrot.WWW.First.Premia +
                this.daneRaportu.Obrot.K_50_50.First.Premia +
                this.daneRaportu.Obrot.SSS.First.Premia +
                this.daneRaportu.Obrot.Uproszczona.First.Premia;

            this.sumaTurystyka.Middle.Obrot =
                this.daneRaportu.Obrot.Travella.Middle.Obrot +
                this.daneRaportu.Obrot.WWW.Middle.Obrot +
                this.daneRaportu.Obrot.K_50_50.Middle.Obrot +
                this.daneRaportu.Obrot.SSS.Middle.Obrot +
                this.daneRaportu.Obrot.Uproszczona.Middle.Obrot;

            this.sumaTurystyka.Middle.Premia =
                this.daneRaportu.Obrot.Travella.Middle.Premia +
                this.daneRaportu.Obrot.WWW.Middle.Premia +
                this.daneRaportu.Obrot.K_50_50.Middle.Premia +
                this.daneRaportu.Obrot.SSS.Middle.Premia +
                this.daneRaportu.Obrot.Uproszczona.Middle.Premia;

            this.sumaTurystyka.Last.Obrot =
                this.daneRaportu.Obrot.Travella.Last.Obrot +
                this.daneRaportu.Obrot.WWW.Last.Obrot +
                this.daneRaportu.Obrot.K_50_50.Last.Obrot +
                this.daneRaportu.Obrot.SSS.Last.Obrot +
                this.daneRaportu.Obrot.Uproszczona.Last.Obrot;

            this.sumaTurystyka.Last.Premia =
                this.daneRaportu.Obrot.Travella.Last.Premia +
                this.daneRaportu.Obrot.WWW.Last.Premia +
                this.daneRaportu.Obrot.K_50_50.Last.Premia +
                this.daneRaportu.Obrot.SSS.Last.Premia
            this.daneRaportu.Obrot.Uproszczona.Last.Premia;

            this.sumaTurystyka.Premia =
                this.sumaTurystyka.Travella.Premia +
                this.sumaTurystyka.WWW.Premia +
                this.sumaTurystyka.K_50_50.Premia +
                this.sumaTurystyka.SSS.Premia +
                this.sumaTurystyka.Uproszczona.Premia;

            this.sumaTurystyka.Obrot =
                this.sumaTurystyka.WWW.Obrot +
                this.sumaTurystyka.K_50_50.Obrot +
                this.sumaTurystyka.Travella.Obrot +
                this.sumaTurystyka.SSS.Obrot +
                this.sumaTurystyka.Uproszczona.Obrot;
        },
        wartoscUslug() {
            for (let i = 0; i < Object.keys(this.uslugi).length; i++) {
                this.kluczeUslug.push(Object.keys(this.uslugi)[i]);
                if (this.uslugi[this.kluczeUslug[i]]) {
                    this.sumaTurystyka.wartoscUslug += this.uslugi[
                        this.kluczeUslug[i]
                    ].Premia;
                }
            }
        },
        nazwyHoteli() {
            for (let i = 0; i < Object.keys(this.hotele).length; i++) {
                this.kluczeHoteli.push(Object.keys(this.hotele)[i]);
            }
        },
        getDane(miesiacRaportu, rokRaportu) {
            if ((miesiacRaportu || rokRaportu) == (null || 0)) {
                this.miesiacRaportu = this.dzisiejszaData.getMonth();
                this.rokRaportu = this.dzisiejszaData.getFullYear();
            }
            this.updateNaApce();
            this.$http
                .get(
                    `${SettingsService.apiUrl}/premie-miesieczne-api/policz-dla-sprzedawcy/${this.rokRaportu}/${this.miesiacRaportu}`
                )
                .then(
                    response => {
                        this.problem = false;
                        this.$nextTick(function () {
                            this.daneRaportu = response.body;
                            if (this.daneRaportu.Obrot.Travella == undefined && this.daneRaportu.Obrot.WWW == undefined && this.daneRaportu.Obrot.K_50_50 == undefined && this.daneRaportu.Obrot.SSS == undefined) {
                                this.daneRaportu.Obrot = this.daneObrotu;
                            }
                            this.uslugi = response.body.Uslugi;
                            this.wartoscUslug();
                            this.hotele = response.body.Hotele;
                            this.nazwyHoteli();
                            this.$nextTick(function () {
                                this.sumaPieniedzy();
                            });
                            this.idUzytkownika = response.body.UzytkownikId;
                            // this.sprawdzSprzedazObca();
                            this.updateNaApce();
                        });
                    },
                    error => {
                        console.error(error);
                        this.problem = true;
                        this.updateNaApce();
                     }
                );
        },
        sprawdzPodwladnych() {
            this.$http
                .get(
                    `${SettingsService.apiUrl}/premie-miesieczne-api/podwladni`
                )
                .then(response => {
                    this.kierownik = 1;
                    this.danePodwladnych.Podwladni = response.body.Podwladni;
                    for (let i = 0; i < this.danePodwladnych.Podwladni.length; i++) {
                        this.pracownik.push(response.body.Podwladni[i]);
                        this.loginy.push(response.body.Podwladni[i].Login);
                    }
                    this.pracownik[this.pracownik.length] = [{
                        Login: "JA",
                        idUzytkownika: response.body.Podwladni.UzytkownikId
                    }];

                    this.loginy[this.loginy.length] = "JA";
                }),
                error => {
                    console.error(error);
                    this.kierownik = 0;
                };
        },
        wartosciZKwoty100(sprzedazObcaDane) {
            if (sprzedazObcaDane) {
                sprzedazObcaDane.forEach(sprzedazObca => {
                    if (sprzedazObca.kwota100) {
                        sprzedazObca.kwota100 = sprzedazObca.kwota100 / 100;
                    }
                })
            }

            return sprzedazObcaDane;
        },
        wartosciDoKwoty100(sprzedazObcaDane) {
            if (sprzedazObcaDane.ksk.kwota100) {
                sprzedazObcaDane.ksk.kwota100 = parseInt(sprzedazObcaDane.ksk.kwota100 * 100);
            }

            if (sprzedazObcaDane.bonWakacyjny.kwota100) {
                sprzedazObcaDane.bonWakacyjny.kwota100 = parseInt(sprzedazObcaDane.bonWakacyjny.kwota100 * 100);
            }

            if (sprzedazObcaDane.sprzedazObca.kwota100 || sprzedazObcaDane.sprzedazObca.prowizja100) {
                sprzedazObcaDane.sprzedazObca.kwota100 = parseInt(sprzedazObcaDane.sprzedazObca.kwota100 * 100);
                sprzedazObcaDane.sprzedazObca.prowizja100 = parseInt(sprzedazObcaDane.sprzedazObca.prowizja100 * 100);
            }

            return sprzedazObcaDane;
        },
        filesChange(plik) {
            var reader = new FileReader();
            reader.readAsDataURL(plik[0]);
            let that = this;
            reader.onload = function () {
                that.sprzedazObcaDaneModal.sprzedazObca.pdf.nazwaPliku = plik[0].name;
                that.sprzedazObcaDaneModal.sprzedazObca.pdf.plikBase64 = reader.result;
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
        // dodajSprzedazObca() {
        //     this.dialogDisplay = !this.dialogDisplay;
        //     let sprzedazObcaKwota100Dane = this.wartosciDoKwoty100(this.sprzedazObcaDaneModal);
        //     this.$http
        //         .post(`${SettingsService.apiUrl}/premie-miesieczne-api/sprzedaz-dodatkowa/dodaj/${this.rokRaportu}/${this.miesiacRaportu}`, sprzedazObcaKwota100Dane)
        //         .then(() => {
        //             this.sprawdzSprzedazObca();
        //             this.sprzedazObcaDaneModal = {
        //                 typ: "",
        //                 ksk: {
        //                     imieNazwisko: "",
        //                     kwota100: null
        //                 },
        //                 bonWakacyjny: {
        //                     kodBonu: "",
        //                     kwota100: null
        //                 },
        //                 sprzedazObca: {
        //                     nazwaSprzedazy: "",
        //                     kwota100: null,
        //                     prowizja100: null,
        //                     pdf: {
        //                         nazwaPliku: "",
        //                         plikBase64: ""
        //                     }
        //                 }
        //             };
        //             this.getDane(this.miesiacRaportu, this.rokRaportu);
        //             this.$toast.add({ severity: 'success', summary: 'Dodany', detail: "Rekord Dodany", life: 6000 });
        //         }).catch((error) => {
        //             console.error(error);
        //             this.$toast.add({ severity: 'error', summary: 'Błąd', detail: error.body, life: 6000 });
        //         });
        // },
        // usunSprzedazObca(idRekordu) {
        //     this.$http
        //         .delete(`${SettingsService.apiUrl}/premie-miesieczne-api/sprzedaz-dodatkowa/usun/${idRekordu}`)
        //         .then(() => {
        //             this.sprawdzSprzedazObca();
        //             this.getDane(this.miesiacRaportu, this.rokRaportu);
        //             this.$toast.add({ severity: 'success', summary: 'Usunięto', detail: "Rekord Usunięty", life: 6000 });
        //         }),
        //         error => {
        //             console.error(error);
        //             this.$toast.add({ severity: 'error', summary: 'Błąd', detail: error.body, life: 6000 });
        //         }
        // },
        // sprawdzSprzedazObca() {
        //     this.$http
        //         .get(`${SettingsService.apiUrl}/premie-miesieczne-api/sprzedaz-dodatkowa/lista/${this.rokRaportu}/${this.miesiacRaportu}/${this.idUzytkownika}`)
        //         .then(response => {
        //             this.$nextTick(function () {
        //                 this.sprzedazObcaDanePobrane = response.body;
        //                 this.sprzedazObcaDanePobrane = this.wartosciZKwoty100(this.sprzedazObcaDanePobrane);
        //             });
        //         }),
        //         error => {
        //             console.error(error);
        //         }
        // },
        sprawdzModal() {
            if (this.sprzedazObcaDaneModal.typ == "KSK" && this.sprzedazObcaDaneModal.ksk.kwota100) {
                this.modalDisabled = true;
            } else if (this.sprzedazObcaDaneModal.typ == "Sprzedaz bonu" && this.sprzedazObcaDaneModal.bonWakacyjny.kwota100) {
                this.modalDisabled = true;
            } else if (
                this.sprzedazObcaDaneModal.typ == "Sprzedaz obca" &&
                this.sprzedazObcaDaneModal.sprzedazObca.pdf.plikBase64 &&
                this.sprzedazObcaDaneModal.sprzedazObca.pdf.nazwaPliku &&
                this.sprzedazObcaDaneModal.sprzedazObca.kwota100 &&
                this.sprzedazObcaDaneModal.sprzedazObca.prowizja100) {
                this.modalDisabled = true;
            }
        },
        sprawdzGrupe() {
            this.$http.get(`https://menu${SettingsService.env}.travella.r.pl/api/menu`).then((data) => {
                data.body.grupy.forEach(grupa => {
                    if (grupa == 'Oddzial') {
                        this.oddzial = true;
                    }
                    if (grupa == 'Callcenter') {
                        this.callcenter = true;
                    }
                })
            })
        },
        /* eslint-disable no-unused-vars*/
        getDanePodwladnego() {
            this.updateNaApce();
            this.$http
                .get(
                    `${SettingsService.apiUrl}/premie-miesieczne-api/glob/${this.idUzytkownika}/${this.rokRaportu}/${this.miesiacRaportu}`
                )
                .then(response => {
                    this.$nextTick(function () {
                        this.daneRaportu = response.body;
                        if (
                            response.body.Obrot.K_50_50 == "" ||
                            response.body.Obrot.K_50_50 == null
                        ) {
                            this.daneRaportu.Obrot = {
                                K_50_50: {
                                    First: {
                                        Obrot: 0,
                                        Premia: 0
                                    },
                                    Last: {
                                        Obrot: 0,
                                        Premia: 0
                                    },
                                    Middle: {
                                        Obrot: 0,
                                        Premia: 0
                                    }
                                },
                                Travella: {
                                    First: {
                                        Obrot: 0,
                                        Premia: 0
                                    },
                                    Last: {
                                        Obrot: 0,
                                        Premia: 0
                                    },
                                    Middle: {
                                        Obrot: 0,
                                        Premia: 0
                                    }
                                },
                                WWW: {
                                    First: {
                                        Obrot: 0,
                                        Premia: 0
                                    },
                                    Last: {
                                        Obrot: 0,
                                        Premia: 0
                                    },
                                    Middle: {
                                        Obrot: 0,
                                        Premia: 0
                                    }
                                }
                            };
                        }
                        this.uslugi = response.body.Uslugi;
                        this.wartoscUslug();
                        this.$nextTick(function () {
                            this.sumaPieniedzy();
                        });
                        this.updateNaApce();
                    });
                }),
                error => {
                    console.error(error);
                    this.updateNaApce();
                };
        }
    },
    mounted: function () {
        let data = new Date();
        this.miesiacRaportu = data.getMonth() + 1;
        this.rokRaportu = data.getFullYear();
        this.maksymalnaData = 1 + this.dzisiejszaData.getMonth();
        this.maksymalnyRok = this.rokRaportu;
        this.minimalnyMiesiac = this.startProjektuMiesiac;
        this.$nextTick(() => {
            this.miesiac = this.dzisiejszaData.getMonth();
            this.rok = this.dzisiejszaData.getFullYear();
            this.getDane(this.miesiacRaportu, this.rokRaportu);
            this.sprawdzPodwladnych();
            this.maksymalnaData = 1 + this.dzisiejszaData.getMonth();
        });
        this.sprawdzGrupe();
    }
};
